export const constants = {
    isTouch: "ontouchstart" in window ? function () {
        document.body.classList.add("touch-device");
        document.body.classList.add("touch");
        return true;
    }() : function () {
        const ww = $(window).outerWidth();

        document.body.classList.add("is-desktop");
        if (ww < 1200) {
            document.body.classList.add("touch");
        }else{
            document.body.classList.add("no-touch");
        }
        
        return false;
    }(),
    pushEvent: this.isTouch ? "touchstart" : "click",
    doc: document,
    $doc: $("document"),
    win: window,
    _body: document.querySelector("body"),
    $window: $(window),
    $html: $("html"),
    $body: $("body"),
    $wrapper: $(".wrapper"),
    $header: $(".site-header"),
    $main: $(".main"),
    $container: $(".container"),
    $popupsContainer: $(".popups-container"),
    animatedLetters: [],
};


// WEBPACK FOOTER //
// ./assets/js/modules/constants.js